
const PolDocs = () => import('../../components/Policy/AllDocs')

export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Policy'))  {
    routes = [
      {
        path: '/PolDocs',
        name: 'PolDocs',
        component: PolDocs
      },
    ]
  } 
  return routes
}
